/* D1 (03/09/2026) — arrastar carrossel com o mouse, igual ao bloco de depoimentos.
   Aplica-se a qualquer lista com rolagem horizontal (vitrines de produto, blog).
   Toque e trackpad continuam funcionando como antes; isto só acrescenta o mouse. */
(function () {
  var SEL = 'ul.slider--desktop, ul.slider, .blog__track .slide';

  function ligar(el) {
    if (el.dataset.d1drag) return;
    if (el.scrollWidth <= el.clientWidth + 4) return;
    el.dataset.d1drag = '1';
    el.classList.add('d1-drag');

    var down = false, moveu = false, x0 = 0, s0 = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moveu = false; x0 = e.clientX; s0 = el.scrollLeft;
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - x0;
      if (!moveu && Math.abs(d) < 5) return;
      if (!moveu) { moveu = true; el.classList.add('is-dragging'); el.setPointerCapture(e.pointerId); }
      el.scrollLeft = s0 - d;
      e.preventDefault();
    });

    function soltar(e) {
      if (!down) return;
      down = false;
      if (moveu) {
        el.classList.remove('is-dragging');
        try { el.releasePointerCapture(e.pointerId); } catch (err) {}
        setTimeout(function () { moveu = false; }, 0);
      }
    }
    el.addEventListener('pointerup', soltar);
    el.addEventListener('pointercancel', soltar);
    el.addEventListener('click', function (e) { if (moveu) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  function varrer() { document.querySelectorAll(SEL).forEach(ligar); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();
  window.addEventListener('load', varrer);
  window.addEventListener('resize', varrer);
})();
